import React from 'react';
import { Card, Typography, Space, Row, Col } from 'antd';
import styled from 'styled-components';

const { Title, Text } = Typography;

interface ContentCardProps {
  title?: string;
  subtitle?: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
  loading?: boolean;
  extra?: React.ReactNode;
  className?: string;
  size?: 'small' | 'default' | 'large';
}

const StyledCard = styled(Card)`
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 
    0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;

  &:hover {
    box-shadow: 
      0 10px 15px -3px rgba(0, 0, 0, 0.1),
      0 4px 6px -2px rgba(0, 0, 0, 0.05);
    transform: translateY(-2px);
  }

  .ant-card-head {
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    padding: 20px 24px 16px;
    min-height: auto;
  }

  .ant-card-head-title {
    padding: 0;
    font-size: 18px;
    font-weight: 600;
    color: #1a1a2e;
  }

  .ant-card-body {
    padding: 16px 24px 24px;
  }

  &.content-card-small .ant-card-head {
    padding: 16px 20px 12px;
  }

  &.content-card-small .ant-card-body {
    padding: 20px;
  }

  &.content-card-large .ant-card-head {
    padding: 24px 32px 20px;
  }

  &.content-card-large .ant-card-body {
    padding: 32px;
  }
`;

const CardHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
`;

const HeaderContent = styled.div`
  flex: 1;
`;

const CardTitle = styled(Title)`
  &.ant-typography {
    margin-bottom: 4px;
    font-size: 18px;
    font-weight: 600;
    color: #1a1a2e;
    line-height: 1.3;
  }
`;

const CardSubtitle = styled(Text)`
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  line-height: 1.4;
`;

const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 16px;
`;

export const ContentCard: React.FC<ContentCardProps> = ({
  title,
  subtitle,
  children,
  actions,
  loading = false,
  extra,
  className = '',
  size = 'default'
}) => {
  const cardClassName = `content-card-${size} ${className}`.trim();

  const cardTitle = (title || subtitle) ? (
    <CardHeader>
      <HeaderContent>
        {title && <CardTitle level={4}>{title}</CardTitle>}
        {subtitle && <CardSubtitle>{subtitle}</CardSubtitle>}
      </HeaderContent>
      {actions && <HeaderActions>{actions}</HeaderActions>}
    </CardHeader>
  ) : null;

  return (
    <StyledCard
      title={cardTitle}
      loading={loading}
      extra={extra}
      className={cardClassName}
      bordered={false}
    >
      {children}
    </StyledCard>
  );
};




